import React from "react";

function footer() {
  return (
    <footer className="dashboard-footer">
      <div className="text-color app-content  footer p-2 text-center footer-container text-gray">
        Copyright © {new Date().getFullYear()} by Inmate Inbox. All Rights Reserved.
      </div>
    </footer>
  );
}

export default footer;
